'use client'
import { cn } from 'lib/utils'
import { useRouter } from 'next/navigation'
import { useParams } from 'next/navigation'

const PolygonButtonWithBorder = ({
    title,
    Icon,
    className,
    link
}: {
    title: string
    Icon?: React.ReactNode
    className?: string
    link?: string
}) => {
    const router = useRouter()
    const params = useParams()
    const lang = params.lang
    return (
        <button
            onClick={() => {
                if (link) {
                    if (link.startsWith('https')) {
                        window.open(link, '_blank')
                    } else {
                        router.push(`/${lang}/${link.replace(/^\/+/, '')}`)
                    }
                }
            }}
            className={cn(`group relative px-6 py-2 font-medium bg-transparent`, className)}
        >
            <span className='whitespace-nowrap relative z-10 text-pfl_v2_text_test flex items-center gap-3 transition-colors duration-200 group-hover:text-primary-foreground'>
                {title}
                {Icon ? Icon : ''}
            </span>

            <svg
                className='absolute inset-0 w-full h-full -z-10 pointer-events-none'
                viewBox='0 0 100 40'
                preserveAspectRatio='none'
                xmlns='http://www.w3.org/2000/svg'
                aria-hidden='true'
            >
                <polygon points='6,0 100,0 100,28 94,40 0,40 0,14' fill='currentColor' fillOpacity='0.06' />

                <polygon
                    points='6,0 100,0 100,28 94,40 0,40 0,14'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='1'
                    strokeLinejoin='bevel'
                    strokeLinecap='butt'
                    vectorEffect='non-scaling-stroke'
                />
            </svg>
        </button>
    )
}

export default PolygonButtonWithBorder
